









































import { Vue, Component, Prop } from "@/shared/vuepack";
import moment from "moment";

@Component
export default class PayrollMonthEdit extends Vue {

  @Prop({required: true})
  year: number;

  @Prop({required: true})
  month: number; // zero based month

  @Prop({required: true})
  bankHolidays: number[]; // day numbers of the bank holidays

  @Prop({required: true})
  selectedDays: number[]; // day numbers of the selected days

  @Prop({required: true})
  flaggedDays: number[]; // day numbers of the flagged days

  @Prop({required: false})
  disable: { daysBefore?: number; allInput?: boolean };

  get calendarTitle () {
    return moment([this.year, this.month]).format("MMMM YYYY");
  }

  get calendarArray () {
    const monthStart = moment([this.year, this.month]);
    let daysCounter = 0;
    const totalDays = monthStart.daysInMonth();
    const rows = [];
    for (let repeat = 0; repeat < 6; repeat++) {
      for (let i = 0; i < 7; i++) {
        if (daysCounter < totalDays) {
          if (i === 0) {
            rows.push([]);
          }
          const row = rows[rows.length - 1];
          if (daysCounter === 0 && i < monthStart.day()) {
            row[i] = 0;
          }
          else {
            daysCounter++;
            row[i] = daysCounter;
          }
        }
      }
    }
    return rows;
  }

  hasDay (values: number[], day: number) {
    return undefined !== values.find(value => value === day);
  }

  isSelected (day: number) {
    return this.hasDay(this.selectedDays, day);
  }

  isFlagged (day: number) {
    return this.isSelected(day) && this.hasDay(this.flaggedDays, day);
  }

  isBankHoliday (day: number) {
    return this.hasDay(this.bankHolidays, day);
  }

  isDisabled (day: number) {
    const filledDisable = (this.disable || {});
    const disableAll = filledDisable.allInput === true;
    return disableAll || (day < this.disable.daysBefore) || this.isBankHoliday(day);
  }

  isSelectable (day: number) {
    if (!this.isDisabled(day)) {
      const dayOfWeek = moment([this.year, this.month, day]).weekday();
      return dayOfWeek > 0 && dayOfWeek < 6;
    }
    return false;
  }

  toggleSelection (day: number) {
    if (day && !this.isDisabled(day)) {
      if (this.isSelected(day)) {
        this.updateValue(this.selectedDays.filter(v => v !== day));
      } else if (this.isSelectable(day)) {
        this.updateValue([...this.selectedDays, day]);
      }
    }
  }

  updateValue (newDaysArray: number[]) {
    this.$emit("change", newDaysArray);
  }
}
